import { render, staticRenderFns } from "./RootPresidentiIdView.vue?vue&type=template&id=5f7f37ac&"
import script from "./RootPresidentiIdView.vue?vue&type=script&lang=ts&"
export * from "./RootPresidentiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports